import { faCode, faCodeBranch, faEnvelope, faUser } from '@fortawesome/free-solid-svg-icons'

const links = [
    {
        id: '#AboutMe',
        icon: faUser
    },
    {
        id: '#projects',
        icon: faCodeBranch
    },
    {
        id: '#tech',
        icon: faCode
    },
    {
        id: '#contact',
        icon: faEnvelope
    },
]

export default links